<script>
  import { draw } from 'svelte/transition'
  import { onMount } from 'svelte'

  let guides
  let showGuides = false
  let scroller
  onMount(() => {
    scroller = ScrollTrigger.create({
      trigger: guides,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => {
        showGuides = !showGuides
      },
      onLeaveBack: () => {
        showGuides = !showGuides
      },
    })
    return () => {
      scroller.kill()
    }
  })
</script>

<div bind:this={guides}>
  {#if showGuides}
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 429.98">
      <defs>
        <style>
          .cls-1 {
            fill: none;
            stroke: #3d3a36;
            stroke-miterlimit: 10;
            stroke-width: 3px;
          }
        </style>
      </defs>
      <g>
        <line
          in:draw={{ duration: 600 }}
          class="cls-1"
          x1="5.47"
          y1="429.98"
          x2="5.47"
          y2="0.01" />
        <line
          in:draw={{ duration: 600, delay: 500 }}
          class="cls-1"
          x1="57.47"
          y1="429.98"
          x2="57.47"
          y2="0.01" />
        <line
          in:draw={{ duration: 600, delay: 1000 }}
          class="cls-1"
          x1="120.47"
          y1="429.98"
          x2="120.47"
          y2="0.01" />
        <line
          in:draw={{ duration: 600, delay: 1500 }}
          class="cls-1"
          x1="172.47"
          y1="429.98"
          x2="172.47"
          y2="0.01" />
        <line
          in:draw={{ duration: 600, delay: 2000 }}
          class="cls-1"
          x1="410.47"
          y1="403.98"
          x2="410.47"
          y2="230.01" />
        <line
          in:draw={{ duration: 600, delay: 2500 }}
          class="cls-1"
          x1="461.47"
          y1="403.98"
          x2="461.47"
          y2="230.01" />
        <path
          in:draw={{ duration: 2000 }}
          class="cls-1"
          d="M576.45,129.4V102.93c0-48.66-31.27-85.47-82.51-85.47-49,0-79.51,38.27-79.51,85.47v67.53" />
        <path
          in:draw={{ duration: 600, delay: 1500 }}
          class="cls-1"
          d="M524.88,129.41V103.28c0-19.85-12.73-32.45-31-32.45s-31,12.6-31,32.45v67.08" />
        <path
          in:draw={{ duration: 1000, delay: 2000 }}
          class="cls-1"
          d="M989,129.4V102.93c0-47.2-33.84-86.47-80.51-86.47-52,0-84.51,37.25-84.51,86.47v27.31" />
        <path
          in:draw={{ duration: 600, delay: 2500 }}
          class="cls-1"
          d="M939.43,129.41V100.28c0-19.1-10.76-34.45-31-34.45-22,0-33,15.91-33,34.45v29.86" />
        <circle
          in:draw={{ duration: 1000, delay: 1500 }}
          class="cls-1"
          cx="906.63"
          cy="326.22"
          r="86.14" />
      </g>
    </svg>
  {/if}
</div>
